import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Map from "./map"

export default (props) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          lang
        }
      }

      sites: allSitesJson {
        nodes {
          id: nk_id
          path
        }
      }
    }
  `)

  return <Map {...props} data={data} />
}
